module.exports = __webpack_public_path__ + "img/mlogo.75caaf6b.png";